<template>
  <span>
    <FirstLayerWithChild
      :childs="childs"
      :title="title"
      :width="width"
      :indexParent="indexParent"
      v-if="hasChild"
    />
    <FirstLayerNoChild :title="title" :isTheUrl="isUrl(isTrueUrl)" :href="href" v-else :width="width" :indexParent="indexParent"/>
  </span>
</template>

<script>
import FirstLayerWithChild from "@/Components/Menu/FirstLayerWithChild";
import FirstLayerNoChild from "@/Components/Menu/FirstLayerNoChild";
export default {
  components: {
    FirstLayerWithChild,
    FirstLayerNoChild,
  },
  props: {
    title: String,
    isTheUrl: Boolean,
    href: String,
    hasChild: Boolean,
    childs: Array,
    level: Number,
    width: Number,
    indexParent: Number,
  },
  computed: {
    isTrueUrl(){
      if(this.href.startsWith('/id') || this.href.startsWith('/en')) {
        return this.href.substring(3);
      }

      if(this.href.startsWith('en') || this.href.startsWith('en')) {
        return this.href.substring(2);
      }

      return this.href;
    }
  }
};
</script>

<style>
</style>
